import React from 'react';
import cx from 'classnames';
import { Row, Col, Image } from 'react-bootstrap';
import InputField from 'src/legacy/components/InputField';
import ImageTools from 'src/legacy/services/ImageTools';
import styles from '../../accountManagementView.module.scss';
import { localizedStrings } from 'src/localization/index.jsx';

const FavIcon = '/images/Paperflite.png'; 
class AccountSettings extends React.Component {
  constructor(props) {
    super(props);

    this._handleChange = this._handleChange.bind(this);
    this._handleFavIconUpload = this._handleFavIconUpload.bind(this);

    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedAccountSettings = this.localizedSettings.account.account_management.tabs.account_settings;
  }

  _handleChange(field, e) {
    this.props.onChange({
      [field]: e.target.value
    });
  }

  _handleFavIconUpload(e) {
    ImageTools.resize(e.target.files[0], {
      width: 196, // maximum width
      height: 196 // maximum height
    }, (blob, didItResize) => {
      var reader = new FileReader();
      reader.onload = (e) => {
        this.props.onChange({
          "updatedFavIcon": e.target.result
        });
      };

      reader.readAsDataURL(blob);
    });
  }

  renderFavIcon() {
    if (this.props.value.updatedFavIcon) {
      return this.props.value.updatedFavIcon;
    }

    if (this.props.value.favIcon && this.props.value.favIcon.full) {
      return this.props.value.favIcon.full;
    }

    return FavIcon;
  }

  render() {
    return (
      <div className={styles.accountSettings}>
        <Row className={styles.row}>
          <Col md={8}>
            <InputField
              className={styles.inputField}
              title={`${this.localizedAccountSettings.form.company_name}:`}
              placeholder=""
              type="text"
              value={this.props.value.name}
              focus={true}
              reference="focusOn"
              onChange={this._handleChange.bind(this, 'name')}
              errorMessage={null}
            />
          </Col>
          <Col md={8}>
            <InputField
              className={styles.inputField}
              title={`${this.localizedAccountSettings.form.company_url}:`}
              value={this.props.value.companyUrl}
              placeholder=""
              type="text"
              onChange={this._handleChange.bind(this, 'companyUrl')}
              errorMessage={null}
            />
          </Col>
        </Row>
        <Row>
          <Col md={8} className={styles.favIconField}>
            <h5 className={styles.label}>{`${this.localizedAccountSettings.form.fav_icon}:`}</h5>
            <div className={styles.favIcon}>
              <div className={styles.iconContainer}>
                <Image src={this.renderFavIcon()} key="icon" />
              </div>
            </div>
            <div className={styles.upload}>
              <div>{this.localizedAccountSettings.form.actions.edit_fav_icon}</div>
              <div className={styles.preferredSize}>{this.localizedAccountSettings.form.actions.description}</div>
              <input type="file" className="file-input-hidden" accept="image/*"
                onChange={this._handleFavIconUpload}></input>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

export default AccountSettings;